import React from "react";
import IOrder from "../../../models/IOrder";
import { Link } from "react-router-dom";

type Props = {
    order: IOrder;
};

export const OrderEntryPurchaseOrderPanel = (props: Props) => {
    return (
        <div className={"OrderEntryPurchaseOrderPanel"}>
            <div className={"p-2"}>
                {props.order.Purchase_Orders?.map((poDetail) => {
                    return (
                        <div key={poDetail.guid} className={"mt-2"}>
                            <Link to={`/purchase_orders/${poDetail.guid}`}>
                                {poDetail.name} - {poDetail.Vendor_Source?.name}
                            </Link>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
